export const translateAuthorities = (authority) => {
    const authoritiesTranslations = {
        VIEW_VR_LIST: "Voir la liste VR",
        VIEW_PAYMENT: "Voir le paiement",
        VIEW_SCHEDULE: "Voir le planning",
        VIEW_INSPECTIONS: "Voir les inspections",
        DISPATCH_TASKS: "Dispatcher les tâches",
        VIEW_SERVICE_PROPOSAL_FILTER: "Voir le filtre de proposition de service",
        VIEW_DESIGNATE_PARTIES_FILTER: "Voir le filtre de désignation des parties",
        VIEW_ENTER_CUSTOMER_TEL_FILTER: "Voir le filtre d'entrée du numéro de téléphone client",
        VIEW_REPARATION_MISSION_ACCEPTANCE_FILTER: "Voir le filtre d'acceptation de mission de réparation",
        VIEW_UPLOAD_QUOTATION_FILTER: "Voir le filtre de téléchargement des devis",
        VIEW_CLIENT_PART_CALCULATION_FILTER: "Voir le filtre de calcul de la part client",
        VIEW_UPLOAD_INVOICE_AND_PICTURES_FILTER: "Voir le filtre de téléchargement des factures et photos",
        VIEW_REPARATION_ENTRY_DATE_INDICATION_FILTER: "Voir le filtre d'indication de la date d'entrée de réparation",
        VIEW_CAR_EXIT_VOUCHER_GENERATION_FILTER: "Voir le filtre de génération du bon de sortie de véhicule",
        VIEW_VALIDATE_REGLEMENTS_FILTER: "Voir le filtre de validation des règlements",
        VIEW_CALCULATE_PART_FILTER: "Voir le filtre de calcul de la part",
        VIEW_ADVANCED_ACTIONS_BUTTON: "Voir le bouton d'actions avancées",
        VIEW_REPAIR_MISSIONS: "Voir les missions de réparation",
        VIEW_REPARATION_BUTTON: "Voir le bouton de réparation",
        VIEW_REPLACEMENT_CAR_REQUEST_MONTHLY: "Voir le statisitique de demande de remplacement de véhicule mensuel",
        CREATE_INSPECTION_MISSION: "Créer une mission d'expertise",
        DELETE_INSPECTION_MISSION: "Supprimer une mission d'expertise",
    };

    return authoritiesTranslations[authority] || authority;
};